<template>
    <div class="order-card" :class="[  order.Data.status == 'מוכנה' ? 'orderReady' : 'order-card', order.Data.status == 'נמסרה' ? 'confirmed' : 'order-card', order.Data.status == 'בוטלה' ? 'canceledOrder' : 'order-card']">
        <div class="company">
            <span>
                
                 הקונדיטוריה הירוקה בע"מ
                </span>
                <span>
                                    ח.פ.514519024

                </span>
        </div>
        <div class="order-card-header">
            <div class="right-side">
                <span class="order-id" @click="openOrder(order.ID)">#{{ order.Data.orderNumber  }}</span>
                <span @click="toggleStatusDropdown(order.ID)" :class="[order.Data.status == 'בוטלה' ? 'canceledBadge' : 'select',
                     order.Data.status == 'מוכנה' ? 'readyBadge' : 'select',
                      order.Data.status == 'נמסרה' ? 'shippedBadge' : 'select',
                      order.Data.status == 'שלב הכנה' ? 'inprogressBadge' : 'select',
                       order.Data.status == 'התקבלה' ? 'acceptBadge' : 'select', ]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-receipt-text-icon lucide-receipt-text"><path d="M13 16H8"/><path d="M14 8H8"/><path d="M16 12H8"/><path d="M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z"/></svg>
                    {{ order.Data.status }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg>                </span>
                <div class="status-dropdown" v-if="activeStatusDropdown === order.ID">
                  <ul>
                    <li @click="updateOrderStatus(order.ID, 'התקבלה')">התקבלה</li>
                    <li @click="updateOrderStatus(order.ID, 'מוכנה')">מוכנה</li>
                    <li @click="updateOrderStatus(order.ID, 'נמסרה')">נמסרה</li>
                    <li @click="updateOrderStatus(order.ID, 'בוטלה')">בוטלה</li>
                  </ul>
                </div>
            </div>
            <div class="order-payment-status">
                <span :class="[order.Data.paidStatus == 'שולם' ? 'paid' : 'totalAmount' , order.Data.paidStatus == 'לא שולם' ? 'unPaid' : 'totalAmount'  ]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-banknote-icon lucide-banknote"><rect width="20" height="12" x="2" y="6" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/></svg>
                     {{ order.Data.paidStatus }}
                </span>
            </div>
        </div>
        <div class="order-card-body">
            <div class="client-details">
                <div class="field name" @click="openOrder(order.ID)">
                    <span class="sec-text">שם הלקוח</span>
                    <span class="primary-text">{{ order.Data.fullname  }}</span>
                </div>
                <div class="field phone">
                    <span class="sec-text">מספר הטלפון</span>
                    <span class="primary-text">{{ order.Data.phoneNumber  }}</span>
                </div>
                <div class="field actions">
                    <span class="sec-text">פעולות</span>
                    <span class="primary-text">
                        <img src="/static/img/whatsapp.8b357b4.png" class="whatsappIcon">
                    </span>
                </div>
            </div>
            <div class="order-date">
                <!-- <div class="field name">
                    <span class="sec-text">יום אספקה</span>
                    <span class="primary-text">{{ order.Data.fullname  }}</span>
                </div>
                <div class="field phone">
                    <span class="sec-text">שעת אספקה</span>
                    <span class="primary-text">{{ order.Data.phoneNumber  }}</span>
                </div>
                <div class="field actions">
                    <span class="sec-text">תאריך אספקה</span>
                    <span class="primary-text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle-icon lucide-message-circle"><path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"/></svg>
                    </span>
                </div> -->
                <div class="date-box">
                  {{ order.Data.selectedDateReadable }}
                </div>
                <div class="date-box">
                    {{ order.Data.timeOrder }}
                </div>
            </div>
        </div>
        <div class="order-cart">
            <span class="order-cart-title">
                פרטי הזמנה
            </span>
            <div class="products-list">
                <div class="item" v-for="item in order.Data.cart">
                    <span class="selectedquantity">x{{ item.selectedCount }}</span>
                    <span class="itemName">{{ item.Data.Name }}</span>
                    <span class="subTotal">₪{{ item.Data.Price * item.selectedCount}}</span>
                </div>
                <div class="total">
                    <span>סה"כ לתשלום</span>
                    <span>  ₪{{ order.Data.totalOrderPrice -  order.Data.discount}}</span>
                </div>
                 <div class="note" v-if="order.Data.note.length > 0">
                    <pre><span>הערות:</span><br>{{ order.Data.note }}</pre>
                </div>
            </div>
            <div class="images">
                <!-- <span>Total images: {{ order.Data.orderImg.length  }}</span> -->
                <div v-for="(img,index) in order.Data.orderImg"  :key="'img' + index">
                    <img :src="img" alt=""  >
                    <!-- <button @click="printImage(img)">🖨️ طباعة الصورة</button> -->

                </div>  
            </div>
        </div>
    </div>
</template>

<script>
  import { db } from '../firebase';
  import firebase from "firebase/app";
import moment from 'moment';
import { ref } from 'vue';
export default {
    name: 'orderCard',
    props :['order', 'rowIndex','orders'],
	data () {
    return {
		activeStatusDropdown: null,
    }
  },
  created() {
    //console.log(this.rowIndex);
    // console.log(this.order);
    
    // console.log('created() Total images: ' + this.order.Data.orderImg.length) ;
  },
  updated() {
    // console.log('updated() Total images: ' + this.order.Data.orderImg.length) ;
  },
  methods:{
//     printImage(imageUrl) {
//     if (!imageUrl) {
//       alert("⚠️ لم يتم العثور على الصورة!");
//       return;
//     }

//     const printWindow = window.open("", "_blank");
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>طباعة الصورة</title>
//           <style>
//             @media print {
//               @page {
//                 size: auto;
//                 margin: 0;
//               }
//               body { text-align: center; margin: 0; padding: 20px; }
//               img { max-width: 100%; height: auto; }
//             }
//           </style>
//         </head>
//         <body>
//           <img src="${imageUrl}" onload="window.print();">
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
//   },
toggleStatusDropdown(orderId) {
        this.activeStatusDropdown = this.activeStatusDropdown === orderId ? null : orderId;
      },
async updateOrderStatus(orderId, newStatus) {
  try {
    await firebase.firestore().collection("orders").doc(orderId).update({
      status: newStatus
    });

    this.activeStatusDropdown = null;

  } catch (error) {
    console.error("خطأ أثناء تحديث الحالة:", error);
    alert("حدث خطأ أثناء تحديث الحالة.");
  }
},
	openOrder(){
        let vm = this;
        console.log("openOrder(" + vm.order.Data.fullname +")..");
        vm.$root.selectedOrderObj = vm.order;
        vm.$root.selectedOrderObjID = vm.order.ID;
        vm.$root.selectedOrderIndex = vm.rowIndex;
        vm.$router.push("/SelectedOrderBeta/" + vm.order.ID);
        

        },
        updateStatus(){
            let vm = this;
            let newStatus = vm.order.Data.status;
            db.collection("orders").doc(vm.order.ID).get()
            .then((order) =>{
                let orderData = order.data();
                // let i = vm.$root.selectedOrderIndex;
                orderData.status = newStatus;
                db.collection("orders").doc(vm.order.ID).update(orderData);
                console.log("New Status is :" + newStatus) ;
                alert("סטטוס ההזמנה עודכן בהצלחה")
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
        printElement(){
            const element = this.$refs.myElement;
            const printWindow = window.open('','','height=500, width=400');
            const styles = `
            <style>
                @media print {
                @page{
                    size: 80mm;
                    margin:0;
                }
                    body,html {
                        margin :0;
                        padding: 0;
                        font-size:13px;
                        text-align : right;
                    }
                    .images{
                        display: none;

                    }
                
                }
            </style>
            ` ;
            // const styles = Array.from(document.styleSheets)
            // .map(styleSheet => {
            //     try{
            //         return Array.from(styleSheet.cssRules)
            //         .map(rule => rule.cssText)
            //         .join(' ');
            //     } catch(e) {
            //         return '';
            //     }
            // })
            // .join(' ');

            printWindow.document.write('<html><head><title>Order</title>');

            // printWindow.document.write(`<style>${styles} </style>`);
            printWindow.document.write(styles);
            printWindow.document.write('</head><body>');
            printWindow.document.write(element.outerHTML);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.onafterprint = function (){
                printWindow.close();
            }
            printWindow.onbeforeunload = function (){
                printWindow.close();
            }


            printWindow.print();

            // setTimeout(() =>{
                
            // })
        },
        
        printReceipt() {
            const content = this.$refs.receiptContent.innerHTML; // استخدم innerText بدلًا من innerHTML للطباعة كنص خام

                // إنشاء نافذة جديدة للطباعة
                const printWindow = window.open('', '', 'height=800,width=400');
                      // كتابة المحتوى باستخدام CSS لتحديد الاتجاه من اليمين إلى اليسار
                    printWindow.document.write(`
                        <html><head><title>طباعة الإيصال</title>
                        <style>
                        @import url('https://fonts.googleapis.com/css2?family=Heebo:wght@100;300;400;500;600;700;800;900&display=swap');
                        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@300;400;500;600;700;800;900&display=swap');
                        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@300;400;500;600;700;800;900&display=swap');

                        body {
                            direction: rtl;
                            text-align: right;
                            font-size: 15px;
                            max-width: 80mm;
                            padding:0.5rem;
                            font-family: Heebo , Noto Sans Arabic;
                        }
                        .head .status{
                            display:none;
                            
                        }
                        .head .name ,.head .day ,.head .time ,.head .date,.item .itemName {
                            font-size:17px;
                             line-height: 2;
                             font-weight: 400;
                             padding: 5px ;
                            
                        }
                             .head .name {
                             margin: 0;
                             padding:0;
                                font-weight:700;
                                display: block;
                                text-align:center;
                             }
                          .item .subTotal,
                        .images {
                            display:none;
                        }
                            .col3 .totalAmount {
                            font-size: 17px;
                            text-align: center;
                            border-bottom: 1px solid #e0e0e0;
                            position: relative;
                            padding:10px;

                            }

                        </style>
                        </head><body><div>${content}</div></body></html>
                    `);


                // كتابة المحتوى بدون HTML معقد
                printWindow.document.close();

                // طباعة المحتوى مباشرة
                printWindow.print();

                // إغلاق النافذة بعد الطباعة
                printWindow.onafterprint = function (){
                printWindow.close();
            }
                // ضبط مؤقت لإغلاق النافذة إذا لم يتم إغلاقها

            printWindow.onbeforeunload = function (){
                printWindow.close();
            }
                 

    }
  

        // shareLink(){
        //     let vm = this;
        //     console.log("greenhousecakes.web.app/SelectedOrderBeta/"+ vm.order.ID);
        //     window.open("https://api.whatsapp.com/send?"+ '&text=https://greenhousecakes.web.app/SelectedOrderBeta/'+ vm.order.ID);
        // },


        // printDiv(divId) {
        //     var printContents = document.getElementById(divId).innerHTML;
        //     var win = window.open("","print page", "height=700,width=1000");
        //     win.document.write('<style> *{direction:rtl;margin: 0;padding: 0;box-sizing: border-box;font-family:Noto Sans Hebrew , Noto sans Arabic;} .card{ width:100%; min-height: 420px; border: 2px solid #e0e0e0; padding: 1rem; border-radius: 2px; float: right; margin: 5px 0; /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */ position: relative; } .card:hover{ transform: translatey(-5px); } .card .head{ width: 100%; display: flex; align-items: center; padding-bottom: 0.7rem; border-bottom: 1px solid #e0e0e0; } .head span{ width: calc(100% / 3 ); font-size: 15px; margin: 0 5px; font-family: Noto Sans Hebrew, Noto Sans Arabic; font-weight: 600; text-align: center; overflow: hidden; } .head .name{ text-align: right; } .head .status{ text-align: center; padding: 3px 0px; border-radius: 5px; display:none;} .head .status .select{ width: 100%; padding: 8px; border: 0; font-size: 14px; display:none;} .head .date input{ border: 0; -webkit-appearance:none; } .head .orderNumber{ background-color: #e0e0e0; color: #000; text-align: center; /* padding: 3px 10px; */ border-radius: 5px; } .head .day{ margin-top: 0.7rem; background-color: #f5f5f5; border-radius: 5px; } .head .date{ margin-top: 0.7rem; background-color: #f5f5f5; border-radius: 5px; } .head .time{ margin-top: 0.7rem; background-color: #f5f5f5; border-radius: 5px; } .orderCart{ min-height: 100px; /* margin-bottom: 60px; */ } .orderCart .title{ font-size: 13px; color: #666; font-weight: 500; letter-spacing: 1px; padding: 0.2rem 0px; display: block; } .item{ width: 100%; padding: 0.5rem 0; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; position: relative; } .item span{ margin: 0 5px; font-weight: 500; font-family: Noto Sans Hebrew; } .item .selectedquantity{ color: #666; font-size: 14px; text-align: right; } .item .itemName{ } .item .subTotal{ position: absolute; left: 0; } .acceptBadge{ background-color: #666; color: #fff; text-align: center; border-radius: 5px; width: 100%; padding: 3px; border: 0; font-size: 14px; } .readyBadge{ background-color: #007a4d; color: #fff; text-align: center; border-radius: 5px; width: 100%; padding: 3px; border: 0; font-size: 14px; } .shippedBadge{ background-color: #0265dc; color: #fff; text-align: center; border-radius: 5px; } .canceledBadge{ background-color: #d31510; color: #fff; text-align: center; border-radius: 5px; } .inprogressBadge{ background-color: #666; color: #fff; text-align: center; border-radius: 5px; } .canceledOrder{ background-color: #fdebea; border: 2px solid #ff7770; } .orderReady{ background-color: #f1fef5; border: 2px solid #22a13c; } .confirmed{ background-color: #ebf7ff; border: 2px solid #44b7f0; } .images{ display: flex; align-items: top; justify-content: space-between; flex-wrap: wrap; } .images > div > img{ width: 100px; height: 100px; object-fit: fill; } .note{ margin: 5px 0; padding: 0; } .note span{ background-color:#ffe082 ; padding: 5px 10px; color: #000; display: block; font-family: Noto Sans Hebrew, Noto Sans Arabic; font-size: 14px; } .footerCard{ width: 100%; padding: 0.5rem 0rem; min-height: 40px; background-color: transparent; display: flex; align-items: center; border-top: 2px solid #e0e0e0; justify-content: center; } .footerCard .col3{ width: calc(100% / 2 ); text-align: center; } .footerCard .col3 .totalTitle{ font-size: 13px; font-weight: 500; color: #666; display: block; } .footerCard .col3 .totalAmount{ font-size: 14px; font-weight: 500; color: #000; display: block; display: block; } .footerCard .col3 .paid{ background-color: #dbeada; color: #298f33; padding: 5px 10px; border-radius: 8px; display: inline-block; font-family: Noto Sans Hebrew, Noto Sans Arabic; } .footerCard .col3 .unPaid{ background-color: #fbe7e2; color: #dc1213; padding: 5px 10px; border-radius: 8px; display: inline-block; font-family: Noto Sans Hebrew, Noto Sans Arabic; } </style>')
        //     win.document.write(printContents);
        //     win.print();
        //     win.close();

        // }

        
  }
}
</script>

<style>
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

.order-card{
    background-color: #fff;
    width: 100%;
    min-height: 400px;
    border: 1px solid #e0e0e0;
    border-radius: 7px;
    float: right;
    /* box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px; */
    position: relative;
    overflow: hidden;
    padding:0 ;
    box-shadow: rgba(14, 63, 126, 0.06) 0px 0px 0px 1px, rgba(42, 51, 70, 0.03) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 2px 2px -1px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.03) 0px 5px 5px -2.5px, rgba(42, 51, 70, 0.03) 0px 10px 10px -5px, rgba(42, 51, 70, 0.03) 0px 24px 24px -8px;
}
.canceledOrder{
    border: 2px solid #d7130e;
}
.orderReady{
    border: 2px solid #54c34e;
}
.confirmed{
    border: 2px solid #2595dc;
}
.company{
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:  0.5rem;
    border-bottom: 1px solid #e0e0e0;
}
.company span{
    color: #000;
    font-size: 12px;
    font-family: 'Noto Sans Hebrew';
}
.order-card-header{
    padding:0.75rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
}
.order-card-header .right-side{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: 0;
}

.order-card-header .right-side .order-id{
    font-weight: 700;
    color: #6B7280;
    font-family: Noto Sans Hebrew, Noto Sans Arabic;
    font-size: 16px;
    padding: 3px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    height: 32px;
    cursor: pointer;
}
.order-card-header .right-side .order-status{
    padding: 3px 10px;
    height: 32px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    color:#6B7280 ;
    font-size: 14px;
    font-weight: 500;
    background-color: #f2f2f3;
    margin-right: 1rem;
    cursor: pointer;
}
.order-card-header .right-side .order-status svg{
    color: #6B7280;
    cursor: pointer;
}
.down-arrow-icon{
    margin-right: 8px;
}
.status-dropdown{
    min-width: 150px;
    min-height: 100px;
    padding: 0.5rem  ;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    position: absolute;
    z-index: 999;
    right: 6.4rem;
    top: 5.5rem;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  }
  .status-dropdown ul{
    width: 100%;
    padding: 0;
    margin: 0;
  }
  .status-dropdown ul li{
    list-style: none;
    padding: 7px 5px ;
    font-size: 14px;
    color: #151515;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: 500;

  }
  .status-dropdown ul li:hover{
    background-color: #f5f5f5;
    border-radius: 5px;

  }
.order-card-header .order-payment-status{
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 0;
}
/* ORDER STATUS CSS */
.acceptBadge{
    padding: 3px 10px;
    height: 32px;
    border: 1px solid #6c757d;
    border-radius: 10px;
    color: #363636;
    font-size: 14px;
    font-weight: 500;
    background-color: rgba(42, 51, 70, 0.03);
    margin-right: 1rem;
    cursor: pointer;
}
.readyBadge{
    padding: 3px 10px;
    height: 32px;
    border: 1px solid #54c34e;
    border-radius: 10px;
    color:#fff ;
    font-size: 14px;
    font-weight: 500;
    background-color: #54c34e;
    margin-right: 1rem;
    cursor: pointer;
}
.shippedBadge{
    padding: 3px 10px;
    height: 32px;
    border: 1px solid #2595dc;
    border-radius: 10px;
    color:#fff;
    font-size: 14px;
    font-weight: 500;
    background-color: #2595dc;
    margin-right: 1rem;
    cursor: pointer;
}
.canceledBadge{
    padding: 3px 10px;
    height: 32px;
    border: 1px solid #d7130e;
    border-radius: 10px;
    color:#fff ;
    font-size: 14px;
    font-weight: 500;
    background-color: #d7130e;
    margin-right: 1rem;
    cursor: pointer;
}
.inprogressBadge{
    padding: 3px 10px;
    height: 32px;
    border: 1px solid #f7b46d;
    border-radius: 10px;
    color:#fff ;
    font-size: 14px;
    font-weight: 500;
    background-color: #f7b46d;
    margin-right: 1rem;
    cursor: pointer;
}

/* END OF ORDER STATUS CSS */
.order-card-header .order-payment-status .payment-status {
    padding: 3px 10px;
    height: 32px;
    border: 1px solid rgb(51 125 60);
    border-radius: 10px;
    color:rgb(51 125 60) ;
    font-size: 14px;
    font-weight: 500;
    background-color: rgb(212 254 216);
}
.order-card-body{
    padding: 0 0.5rem;
    display: flex;
    justify-content: start;
    flex-direction: column;
    width: 100%;
    background-color: #fff;
}
.order-card-body .client-details,
.order-card-body .order-date{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background-color: #fff;
    padding: 0.5rem 
}

.order-card-body .order-date{
    justify-content: flex-start;
}
.client-details .field,
.order-date .field{
    display: flex;
    flex-direction: column;
}
.client-details .field .sec-text,
.order-date .field .sec-text{
    color: #6B7280;
    font-size: 13px;
}
.client-details .field .primary-text,
.order-date .field .primary-text{
    font-size: 14px;
    color: #1c1c1c;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
    font-weight: 600;
}
.client-details .field  img{
    width: 24px;
    cursor: pointer;
}
.paid{
    padding: 3px 10px;
    height: 32px;
    border: 1px solid rgb(51 125 60);
    border-radius: 10px;
    color:rgb(51 125 60) ;
    font-size: 14px;
    font-weight: 500;
    background-color: rgb(212 254 216);
}
.unPaid{
     padding: 3px 10px;
    height: 32px;
    border: 1px solid rgb(242 73 99);
    border-radius: 10px;
    color:rgb(242 73 99) ;
    font-size: 14px;
    font-weight: 500;
    background-color: rgb(255 248 248);

}
.order-date .date-box{
    color: #1c1c1c;
    font-family: Noto Sans Hebrew, Noto Sans Arabic;
    font-size: 14px;
    padding: 3px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    height: 32px;
    font-weight: 600;
}
.order-date .date-box:nth-child(2){
    margin-right: 1rem;
}
.order-cart{
    width: 100%;
    margin: 0;
    background-color: #fff;
}
.order-cart .order-cart-title{
    display: block;
    font-size: 14px;
    color: #6B7280;
    padding: 0.25rem 0.75rem;
}
.products-list{
    padding: 0 0.25rem;
}
.item{
    width: 100%;
    padding: 0.5rem 0;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    position: relative;
}
.item span{
    margin: 0 5px;
    font-weight: 4s00;
    font-family: 'Noto Sans Hebrew';
}
.item .selectedquantity{
    color: #666;
    font-size: 14px;
    text-align: right;
}
.item .subTotal{
    position: absolute;
    left: 0.5rem;
}
.products-list .total{
    padding: 0.5rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #1c1c1c;
    font-size: 16px;
    font-weight: 600;
}
.note{
    margin: 5px 0;
    padding: 0;
}
.note pre{
    background-color: #fff3cd;
    padding: 10px;
    color: #000;
    display: block;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
    font-size: 14px;
    border: 1px solid #ffc107;
    border-radius: 10px;
}
.images{
    display: flex;
    align-items: top;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0.5rem;
}
.images > div > img{
    width: 100px;
    height: 100px;
    object-fit: fill;
}
</style>


// WEBPACK FOOTER //
// src/components/orderCard.vue